<div class="p-4 text-center flex">
  <div class="pt-8">
    <div class="text-7xl font-bold justify-center flex">
      Oops!
    </div>
    <div class="text-5xl font-bold justify-center flex">
      There has been a Bio-Disconnect.
    </div><br />
    <div class="italic font-normal text-xl">Error Code: 404</div>
    <div class="text-2xl justify-center text-left flex px-8 pt-8">
      <div>
        We searched high and low but unfortunately
        the page you are looking for does not exist.
        <br /><br />
        Please select an app from the menu on the left
        or visit our <a class="internal-link text-2xl" href="/portal-home">homepage</a>.
      </div>
    </div>
  </div>
  <div>
    <img src="/assets/images/mouse-disconnect.png">
  </div>
</div>
